import { UATConstants } from 'src/Common/Models/UATConstants';
import { ITenantUIConfig, TenantProvider } from './interface';
import { CAPSLFilterConfig } from './filters/CAPSLFilterConfig';
export const CAPSLTenantConfig: Partial<ITenantUIConfig> = {
  nodeName: [UATConstants.PlaceholdersAndTitles.CAPSL],
  provider: TenantProvider.ARTEMIS,
  TenantExperience: true,
  FeatureConfig: {
    SensitiveInfoValidation: false,
    SensativeInfoErrorCount: false,
    FieldConfig: CAPSLFilterConfig,
    AttachmentConfigurations: [],
    Navigation: {
      GlobalSearch: true,
      Copilot: true,
      Analytics: false,
      RequestAccess: true,
      Settings: true,
      Notifications: true,
      Help: true,
    },
    Hub: {
      Filter: true,
      FilterConfig: CAPSLFilterConfig,
      AreaPath: [UATConstants.McapsCapslAreaPath],
      Title: UATConstants.TenantTitles.CAPSL,
      ADOTitle: UATConstants.TenantADOText.CAPSL,
      Create: [
        {
          Text: UATConstants.CreateActionMenuTitle.CreateCAPSLRequest,
          Key: UATConstants.CreateActionMenuKey.CreateCAPSLRequest,
          NodeName: '',
        },
      ],
      BulkUpload: false,
      DownloadTemplate: false,
      Download: true,
      Email: true,
      LocalSearch: true,
      ColumnOptions: false,
      ColumnOptionsConfig: [],
      SplitMode: true,
      BulkEdit: false,
      BulkEditConfig: [],
      CreateRAID: false,
      DownloadTemplateConfig: {},
      RelatedItem: true,
    },
    ManageAction: {
      NewExperience: true,
      MandateFormPickers: [],
      Header: {
        Tags: true,
        Actions: {
          Follow: true,
          Email: true,
          CopyLink: true,
        },
      },
      Tabs: {
        TechnicalFeedback: false,
        RelatedItems: {
          showRelatedTab: true,
          showTFTCreated: false,
        },
        Attachments: true,
        History: true,
      },
      Panes: {
        CopilotInsights: {
          CustomerInsights: true,
          DiscussionInsights: true,
        },
        StatusUpdate: true,
        ClosureStatement: true,
        Discussion: true,
        Tasks: false,
        EmailConversation: false,
      },
    },
    ManageView: {
      isArtemisIntegrationEnabled: true,
      showAddViewButton: true,
      showAddFolderButton: true,
      showCommandBar: true,
      showPreviewFeatureMessageBar: false,
      showSelectFields: false,
      defaultViewId: '35a2abd7-9e87-4c83-9e53-7d4bb39f3a5f',
      systemViewsFolderId: '95fdda99-a924-4145-b81f-ef660ef08003',
      sharedViewsFolderId: '28a30099-7d25-4001-8c59-2a29c3aba0b8',
    },
  },
};
